import { TaggedError } from "@for-it/domain-lib";
export class CertificationNotApproved extends TaggedError {
    constructor() {
        super("CertificationNotApproved");
    }
}
